import * as React from "react";
import { useStaticQuery } from "gatsby";
import { Helmet } from "react-helmet";
import { MDXProvider } from "@mdx-js/react";
import classNames from "classnames";

import { mdxComponentMap } from "config/mdxComponentMap";
import { DocsHeading } from "components/docs/DocsHeading/DocsHeading";
import { query as SiteLayoutQuery } from "components/layout/SiteLayout/SiteLayout";

import * as styles from "./styles.module.scss";

const DocsLayout = ({
  navigate,
  location,
  pageResources,
  uri,
  pageContext,
  params,
  inline = false,
  children,
  ...other
}) => {
  // FIXME: pageContext/frontMatter not available for self-loaded MDX
  const pageTitle = pageContext?.frontmatter?.title || null;
  const sectionTitle = pageContext?.frontmatter?.sectionTitle || null;
  const leadParagraph = pageContext?.frontmatter?.leadParagraph || true;

  // Populate header, other metadata from gatsby-config.js
  const data = useStaticQuery(SiteLayoutQuery);

  return (
    <div
      className={classNames(
        styles.DocsWrapper,
        inline ? styles.docsInline : styles.docsPage,
        "d-flex",
        "flex-column",
        "flex-fill",
        "docs"
      )}
    >
      <Helmet>
        <title>
          {pageTitle} | {data.site.metadata.title}
        </title>
      </Helmet>
      <div
        {...other}
        className={classNames(
          styles.Docs,
          "d-flex",
          "flex-column",
          "flex-fill"
        )}
      >
        {pageTitle && (
          <DocsHeading
            sectionTitle={sectionTitle}
            leadParagraph={leadParagraph}
          >
            {pageTitle}
          </DocsHeading>
        )}
        <MDXProvider components={mdxComponentMap}>{children}</MDXProvider>
      </div>
    </div>
  );
};

export default DocsLayout;
